
















































import { Component, Mixins } from 'vue-property-decorator';
import GlobalMixins from '@/plugins/mixins';
import Contribution from './Setting/SettingContribution.vue';
import SettingLink from './Setting/SettingLink.vue';

interface Link {
	key: string;
	title: string;
	content: string;
	icon: string;
}

@Component({
	components: {
		Contribution,
		SettingLink,
	},
})
export default class DashboardSetting extends Mixins(GlobalMixins) {

	public config: any = {};
	public linkList: Link[] = [
		{
			key: 'blog',
			title: this.$t('dashboard.setting.menu.blog'),
			content: this.$t('dashboard.setting.menu.blog-desc'),
			icon: 'mdi-post',
		},
		{
			key: 'profile',
			title: this.$t('dashboard.setting.menu.profile'),
			content: this.$t('dashboard.setting.menu.profile-desc'),
			icon: 'mdi-account',
		},
	];

	public get selected() {
		const idx = this.linkList.findIndex(
			(link: Link) => `/${this.$route.params.lang}/dashboard/setting/${link.key}` === this.$route.fullPath,
		);
		return idx > -1 ? [ idx ] : [ 0 ];
	}

	public async mounted() {
		this.$logger.debug('app', 'DashboardSetting mounted');
		this.config = await this.$getConfig();
		console.log(this.$refs.group);
	}

}
